import React, {useState, useEffect} from 'react'
import { Link, useParams, useNavigate } from 'react-router-dom'
import arrowRigt from '../static/images/arrowRight.png'
import arrowRight from '../static/images/8666713_arrow_up_right_icon.png'
import arrowLeft from '../static/images/8666713_arrow_down_left_icon.png'
import circleIcon from '../static/images/8665140_bullseye_target_icon.png'
import arrowTop from '../static/images/8542606_sort_amount_up_alt_icon.png'
import '../static/css/styleControlDetail.css'
import Highcharts from 'highcharts'
import highchartsVariablePie from "highcharts/modules/variable-pie";
import HighchartsReact from 'highcharts-react-official'
import { useSelector } from 'react-redux'
import json from '../static/data/dataControl.json'
import Sidebar from '../componentes/controls/Sidebar'
import { transformDate, decimalWithComma, validateRangeDates } from '../utils/utils'

const Report = () => {

    const style = {
        colors:{
            red: "#FF9B85",
            orange: "#FFD97D",
            green: "#60D394"
        }
    }

    const {id} = useParams()
    const navigate = useNavigate()

    const { allData: data } = useSelector(state => state.data)
    const { allData: templates } = useSelector(state => state.dataTemplates)

    const template = templates.find(element => element.nPlantilla == id)

    const [ type, setType ] = useState(template.Medidas[0].Nombre)
    const [ dateFrom, setDateFrom ] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1).toLocaleDateString('en-CA'))
    const [ dateTo, setDateTo ] = useState(new Date().toLocaleDateString('en-CA'))

    const maxRangeDate = 2 //months
    const now = new Date().toLocaleDateString('en-CA')
    
    const controls = data.filter(element => element.Plantilla == template.Plantilla && new Date(element.FechaDeControl) >= new Date(dateFrom) && new Date(element.FechaDeControl) <= new Date(dateTo))

    const measureTemplate = template.Medidas.find(element => element.Nombre == type)

    const validType = measureTemplate !== undefined

    useEffect(() => {
        setType(template.Medidas[0].Nombre)
    }, [validType, id, template.Medidas])

    const measureControls = validType ? controls.reduce((acc, e) => acc.concat(e.Medidas.find(ms => ms.Tipo == type).Valor), []) : []

    const sobre = measureControls.filter(i => i > measureTemplate.Objetivo + measureTemplate.ToleranciaSuperior)
    const en = measureControls.filter(i => i >= measureTemplate.Objetivo + measureTemplate.ToleranciaInferior && i <= measureTemplate.Objetivo + measureTemplate.ToleranciaSuperior)
    const bajo = measureControls.filter(i => i < measureTemplate.Objetivo + measureTemplate.ToleranciaInferior)

    const uniqueSobre = Array.from(new Set(sobre))
    const uniqueEn = Array.from(new Set(en))
    const uniqueBajo = Array.from(new Set(bajo))

    const dataHist = uniqueSobre.map((i) => {return ({name: i, y: sobre.filter(e => e === i).length, color: style.colors.red})}).concat(
        uniqueEn.map((i) => {return ({name: i, y: en.filter(e => e === i).length, color: style.colors.green})}),
        uniqueBajo.map((i) => {return ({name: i, y: bajo.filter(e => e === i).length, color: style.colors.orange})})
    )

    const verificarMedidas = () => {
        var ngood = 0
        const medidas = json.data[0].Medidas
        for (let i=0; i < medidas.length; i++){
            var good = true
            for (let j=0; j < template.Medidas.length; j++){
                const tipo = template.Medidas[j].Nombre
                const medidaControl = medidas[i].find(element => element.Tipo == tipo)
                const valid = (value) => value < template.Medidas[j].Objetivo + template.Medidas[j].ToleranciaSuperior && value > template.Medidas[j].Objetivo + template.Medidas[j].ToleranciaInferior
                
                good = good ? medidaControl.Valor.every(valid) : false
            }
            if (good){
                ngood++;
            }
        }
        
        return ngood
    }

    const passed = verificarMedidas();

    highchartsVariablePie(Highcharts);

    const optionsColumn = {
        chart: {
            type: 'column'
        },
        title: {
            text: 'Mediciones por valor',
            align: 'center'
        },
        xAxis: {
            visible: false,
            crosshair: true
        },
        yAxis: {
            title: {
                text: 'Cantidad de Mediciones'
            }
        },
        legend: {
            enabled: false
        },
        plotOptions: {
            series: {
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    format: '{point.name}'
                }
            }
        },
        tooltip: {
            headerFormat: '',
            pointFormat: '<span>{point.name} '+ template.Unidad[0].toLowerCase() + template.Unidad.slice(1) +'</span> <br/> Cantidad: {point.y}'
        },
        series: [{
            data: dataHist,
            dataSorting: {
                enabled: true
            }
        }]
    }

    const optionsPie = {
        chart: {
            type: 'variablepie'
        },
        title: { 
            text:'Distribución de mediciones',
            align: 'center'
        },
        tooltip: {
            headerFormat: '',
            pointFormat: '<span style="color:{point.color}">\u25CF</span> <b> {point.name}</b><br/>' +
            'Porcentaje: <b>{point.percentage:.1f}%</b><br/>' +
            'Cantidad: <b>{point.y}</b><br/>'
        },
        series: [{
            minPointSize: 1,
            innerSize: '20%',
            zMin: 0,
            name: 'rango',
            borderRadius: 5,
            data: [{
                name: 'Bajo',
                y: bajo.length,
                z: 4
            }, {
                name: 'En',
                y: en.length,
                z: 5
            }, {
                name: 'Sobre',
                y: sobre.length,
                z: 6
            }],
            colors: [
                style.colors.orange,
                style.colors.green,
                style.colors.red
            ]
        }]
    }

    const optionsColumnTotal = {
        chart: {
            type: 'column'
        },
        title: { 
            text: 'Estado de piezas medidas',
            align: 'center'
        },
        xAxis: {
            visible: false,
            crosshair: true
        },
        yAxis: {
            title: {
                text: 'Piezas'
            }
        },
        legend: {
            enabled: false
        },
        plotOptions: {
            series: {
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    format: '{point.name}'
                }
            }
        },
        tooltip: {
            headerFormat: '',
            pointFormat: '<span>{point.name}</span> <br/> Cantidad: {point.y}'
        },
        series: [{
            data: [
                {
                    name:"Correctas",
                    y: passed,
                    color: style.colors.green
                },
                {
                    name:"Rechazadas",
                    y: json.data[0].Medidas.length - passed,
                    color: style.colors.red
                }
            ],
            dataSorting: {
                enabled: true
            }
        }]
    }

    const checkDates = () => {
        const FD = document.getElementById("FechaDesde");
        const FH = document.getElementById("FechaHasta");

        if(validateRangeDates(FD.value, FH.value, maxRangeDate)){
            FD.setCustomValidity("")
        }
        else FD.setCustomValidity("Rango de fechas superior a 2 meses")
    }

    return (
        <div style={{backgroundColor: "#fafafa",}}>
            <Sidebar page="report"/>
            <div className='centerContent'>
                <p className='location'>Usted está en : Login 
                    <img src={arrowRigt} alt="" /> 
                    <Link to='/templates' className="linkLocation">Plantillas Creadas</Link> 
                    <img src={arrowRigt} alt=""/> 
                    <span className='spanLocation'>Reporte</span> </p>
                <div className='contentTitle'>
                    <h3 className='title'>Reporte Consolidado</h3>
                    <button className="buttonExport">Exportar Datos</button>
                </div>
                <div className='filters'>

                    <form className="dateSelector" method="post" onSubmit={(e)=>{
                        e.preventDefault()
                        if(validateRangeDates(e.target[0].value, e.target[1].value, maxRangeDate)) {
                            setDateFrom(e.target[0].value)
                            setDateTo(e.target[1].value)
                        }
                    }}>

                        <label htmlFor="FechaDesde">Periodo: </label>
                        <input className="dateFilter" type="date" id="FechaDesde" onChange={() => checkDates()} defaultValue={dateFrom} min="2010-01-01" max={now} required></input>
                        <label htmlFor="FechaHasta">-</label>
                        <input className="dateFilter" type="date" id="FechaHasta" onChange={() => checkDates()} defaultValue={dateTo} min="2010-01-01" max={now} required></input>

                        <button type="submit" className="buttonClick">Buscar</button>
                    </form>

                    <div className='typeSelector'>
                        <label htmlFor="selectTemplate">Plantilla: </label>
                        <select id="selectTemplate" defaultValue={template.nPlantilla} className="selectTemplate" onInput={
                            (e) => {
                                e.preventDefault()
                                navigate(`/report/${e.target.value}`)}
                        }>
                            {templates.map( (temp, index) => {
                                return (
                                    <option key={index} value={temp.nPlantilla}>{temp.Plantilla}</option>
                                )
                            })}
                        </select>
                    </div>
                </div>

                <div className='contentDataAndMeasure'>
                    <ul className='list'>
                        <li className='li'> 
                            <span className='titles' >Periodo consolidado: </span> <br/>
                            <p className='textTitle'>{transformDate(dateFrom)}-{transformDate(dateTo)}</p>
                        </li>
                        <li className='li'>
                            <span className='titles' >Dispositivo: </span> <br/>
                            <p className='textTitle'>{template.Dispositivo}</p>
                        </li>
                        <li className='li'>
                            <span className='titles'>Unidad medida: </span> <br/>
                            <p className='textTitle'>{template.Unidad}</p>
                        </li>
                        <li className='li'> 
                            <span className='titles'>Tipo de medida: </span> <br/>
                            <select id="selectType" className="selectorType" value={type} onInput={
                                (e) => {
                                e.preventDefault()
                                console.log("change to:", e.target.value)
                                setType(e.target.value)
                                }}>
                                {template.Medidas.map((element, index) => {
                                    return(<option key={index} value={element.Nombre}>{element.Nombre}</option>)
                                })}
                            </select>
                        </li>
                    </ul>
                </div>

                <div className='contentHistograma'>
                    <div className='trioData'>
                        <div className='contentAData'>
                            <div>
                                <img className='imgs' src={arrowTop} alt=''/>
                            </div>
                            <div>
                                <h3 className='aDataH3'>Piezas Medidas</h3>
                                <p className='bottomDate'>{controls.length}</p>
                            </div>
                        </div>

                        <div className='contentAData'>
                            <div>
                                <img className='imgs' src={arrowTop} alt=""/>
                            </div>
                            <div>
                                <h3 className='aDataH3'>Cantidad de Mediciones</h3>
                                <p className='bottomDate'>{measureControls.length || 0}</p>
                            </div>
                        </div>

                        <div className='contentAData'>
                            <div>
                                <img className='imgs' src={circleIcon} alt=""/>
                            </div>
                            <div>
                                <h3 className='aDataH3'>Objetivo Target</h3>
                                <p className='bottomDate'>{validType ? decimalWithComma(measureTemplate.Objetivo) : 0}</p>
                            </div>
                        </div>
                    </div>

                    <div className='duoData'>
                        <div className='contentAData'>
                            <div>
                                <img className='imgs' src={arrowRight} alt=""/>
                            </div>
                            <div>
                                <h3 className='aDataH3'>Tolerancia Superior</h3>
                                <p className='bottomDate'>+{validType ? decimalWithComma(measureTemplate.ToleranciaSuperior) : 0}</p>
                            </div>
                        </div>

                        <div className='contentAData'>
                            <div>
                                <img className='imgs' src={arrowLeft} alt=""/>
                            </div>
                            <div>
                                <h3 className='aDataH3'>Tolerancia Inferior</h3>
                                <p className='bottomDate'>{validType ? decimalWithComma(measureTemplate.ToleranciaInferior) : 0}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='contentGraphs'>
                    <div className='graphmeasures'>
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={optionsColumn}
                        />
                    </div>
                    <div className='graph'>
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={optionsColumnTotal}
                        />
                    </div>
                    <div className='graph'>
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={optionsPie}
                        />
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Report